import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";

import CoreComponent20 from "../../../assets/Sub-component/CoreComponent20";
import CoreComponent21 from "../../../assets/Sub-component/CoreComponent21";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import Enterpertises2 from "../../../assets/Sub-component/Enterpertises2";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import WebDesignCore from "../../../assets/Sub-component/WebDesignCore";

import dynamic from "../../../assets/Services/Web_design/Offer_custamizable/Dynamic_web.svg";
import resposnsive from "../../../assets/Services/Web_design/Offer_custamizable/Responsive_web.svg";
import WebDesigns from "../../../assets/Services/Web_design/Offer_custamizable/Web_design.svg";

import cusotm from "../../../assets/Services/Web_design/Partner_with/custom_web.svg";
import ecom from "../../../assets/Services/Web_design/Partner_with/Ecom_web.svg";
import mobile from "../../../assets/Services/Web_design/Partner_with/mobile_app_design.svg";
import uiuxs from "../../../assets/Services/Web_design/Partner_with/UIUX.svg";
import webspeed from "../../../assets/Services/Web_design/Partner_with/Web_speed.svg";
import wordpress from "../../../assets/Services/Web_design/Partner_with/wordpress_web.svg";

import bug from "../../../assets/Services/Web_design/Why_choose/Bug_free.svg";
import code from "../../../assets/Services/Web_design/Why_choose/code.svg";
import customize from "../../../assets/Services/Web_design/Why_choose/Customize.svg";
import dynami from "../../../assets/Services/Web_design/Why_choose/Dynamic_market.svg";
import { Link } from "react-router-dom";

import Document_Management_System from '../../../assets/Services/Website_dev/Document_Management_System.svg'
import MobileApplication from '../../../assets/Services/Website_dev/Mobile_Application.svg'
import Mobile_opti from '../../../assets/Services/Website_dev/Mobile-optimized.svg'

import compat from "../../../assets/Android-app-dev/Why-invest-in-android/Compatibility.svg";


import icon from '../../../assets/Services/Website_dev/img.png'
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";

const WebDevelopment = () => {
   const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const content100 = [
    {
      icon: dynamic,
      title: "Content management system",
      desc: "Raiden provides a CMS application that effortlessly builds, updates, and publishes your digital content.",
    },
    {
      icon: resposnsive,
      title: "Social media integration",
      desc: "We make it easy for your followers to connect and interact with your brand, thereby increasing your reach.",
    },
    {
      icon: WebDesigns,
      title: "Web Application",
      desc: "We develop highly useful applications and the best website design that streamlines practical answers to all of your problems.",
    },
    {
      icon: MobileApplication,
      title: "Mobile Application",
      desc: "Raiden delivers a unique and engaging mobile application for both iOS and Android for an appealing user experience.",
    },
    {
      icon: Mobile_opti,
      title: "Mobile-optimized Website",
      desc: "Our website design makes you unique and performs successfully effortlessly across all devices, from desktops to smartphones ",
    },
    {
      icon: Document_Management_System,
      title: "Document Management System",
      desc: "We manage your complicated documents, reducing risks and enhancing your business productivity.",
    },
  ];

  const innovative = {
    maintitle: "Experience Raiden’s    Ecommerce Website ",
    maindesc:
      "Choosing Raiden means collaborating with a partner who develops incredible websites that accelerate your business's expansion, builds strong online communities, and advances your enterprise with flawless execution and strategic accuracy.",

    loop: [
      {
        icon: customize,
        title: "Customized Operations",
        desc: "Raiden's proficiency lies in configuring your e-commerce platform to your business needs. We provide solutions that integrate, enhance, and simplify your daily operations.",
      },

      {
        icon: bug,
        title: "Bug-Free Applications",
        desc: "Bug-Free Applications We undergo extensive testing for quality control so that you can be sure the website is free of bugs. Establishing a space where your customers can easily and uninterruptedly shop online.",
      },
      {
        icon: code,
        title: "Powerful Code",
        desc: "We enable stable code so that your e-commerce website lies on a strong foundation. Experience fast loading, seamless operation even during peak traffic, enhanced security, and long-term flexibility to ensure your investment.",
      },

      {
        icon:dynami ,
        title: "Dynamic Marketing Strategies",
        desc: "Raiden provides strong marketing techniques to create a positive online shopping experience. Our efficient SEO architect uses personalized campaigns and real-time analytics to increase reach and adapt your market strategy.",
      },
    ],
  };

  const vertical = [
    {
      icon: compat,
      title: "Cost-effective",
      line: "line-hori",
    },
    {
      icon: ecom,
      title: "Building credibility",
      line: "line-hori",
    },
    {
      icon: mobile,
      title: "Strategic marketing",
      line: "line-hori",
    },
    {
      icon: uiuxs,
      title: "Supportive service",
      line: "line-hori",
    },
    {
      icon: webspeed,
      title: "Easy maintenance",
      // line: "line-hori",
    },

    // {
    //   icon: wordpress,
    //   title: "custom web Design",
    // },
  ];
  const handleClick=(e)=>{
    
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    setForm({ name: '', email: '', mobile: '', message: '' }); 
    alert("data submitted successfully")
   })
   
  
   .catch((error)=>console.log("error in the api",error))
  
  }
  return (
    <div className="main-page-wrapper overflow-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />
      <div className=" container">
        <div
          className=" row pb-80 padb d-flex align-items-center"
          style={{ minHeight: "100vh",marginTop:'-35px ' }}
        >
          <div className="col-lg-6">
            <h1 className="h1-heading lh-1 me-5 mb-3  lh-sm">
              Website Development Company
            </h1>
            <p className=" me-lg-5 mb-3 pb-lg-3 h1-para lh-base">
              Raiden's 10+ years of expertise with a proficient team of web
              developers creates and maintains the best website design that
              encompasses a wide range of tasks with evolving technologies,
              frameworks, and gains meaningful experiences.
            </p>
            <div className="d-flex  h1-para">
              <Link to="/request-quote">
                <button className="h1-para mt-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
                  Get Your Free Quote
                </button>
              </Link>
            </div>
          </div>

         <Contact/>
        </div>
      </div>

      <div className=" bg-light">
        <div className=" container pt-50 pb-50">
          <div className=" row mb-80 marb">
            <h2 className="col-lg-6 lh-sm h2-heading lh-sm">
              Web Development Service Provider
            </h2>
            <p className="col-lg-6  h1-para lh-base" >
              With Raiden, having a high-tech and sophisticated online presence
              is no longer an upscale objective. We empower our clients by
              providing efficient web development services,
              enhancing online presence, streamlining workflows, and creating
              significant connections.
            </p>
          </div>

          <div>
            <CoreComponent20 content={content100} />
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <div className=" row">
          <div className="col-lg-6 text-center mb-3">
            <img src={icon} style={{ width: "75%" }} alt="web development" />
          </div>
          <div className="col-lg-6">
            <h2 className=" h2-heading lh-base ">
              Optimizing Your Online Presence & Effectiveness
            </h2>
            <p className="mt-lg-4 mt-3" >
              Raiden is an expert website development company,
              designing an incredible online presence and making a compelling
              first impression that brings in visitors as committed customers.
              Our framework makes you dynamic without creating additional
              technical obstacles by providing you with thebest website design
              Raiden, a powerful web design company,that is efficiently
              accessible on Android/iOS, enhances business productivity and
              provides a smooth and engaging experience.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-80 amrt">
        <WebDesignCore vertical={vertical} />
      </div>
    

      <div className="container mt-80 mart">
        <CoreComponent21 innovative={innovative} />
      </div>

      <div>
        <CoreComponent2 />
      </div>

      <div className="container text-center mt-80 mart">
        <h2 className="h2-heading lh-sm">Mastering the Full Spectrum of Website Development </h2>
        <p className="my-3 h1-para lh-base">Excellence and Successful Execution</p>
        <Enterpertises2 />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default WebDevelopment;
